module.exports = __webpack_public_path__ + "static/media/C009.beae5982.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/carousel/C009.jpg
// module id = 292
// module chunks = 0